import React from 'react';
import { getIntl } from '../../../../../utils/intl';
import Stack, { ContentStack } from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';
import ListItem from '../../../../v2BaseComponents/ListItem';
import TitledSection from '../../../../v2BaseComponents/TitledSection';

const intl = getIntl('NoPortalResultsDisplay', {
    cantFindPortalPretext: "Can't Find Your Portal?  ",
    cantFindYourPortalSubText: "Don't worry!",
    letOurTeamKnow:
        "Let our team know. We'll gather the info and work with our partner, 1upHealth, to see if we can locate.",
    inTheMeantime: 'In the meantime, you can still use Primary Record!',
    bullet1: 'Snap a pic of your medical paperwork to load on a note',
    bullet2: 'Enter your key medical contacts',
    bullet3: 'Invite a family member to help you enter medications, visits, or conditions.',
});

export type NoResultsDisplayOwnProps = {
    profileId: string;
};

export type NoResultsDisplayProps = NoResultsDisplayOwnProps;

const NoResultsDisplay: React.FC<NoResultsDisplayProps> = () => {
    return (
        <TitledSection title={intl('cantFindPortalPretext')}>
            <ContentStack>
                <Stack horizontal fullWidth justify="center">
                    <Text variant="h5">{intl('cantFindYourPortalSubText')}</Text>
                </Stack>
                <Text variant="body-1">{intl('letOurTeamKnow')}</Text>
                <Stack vertical fullWidth>
                    <Text variant="body-1">{intl('inTheMeantime')}</Text>
                    {[intl('bullet1'), intl('bullet2'), intl('bullet3')].map((bullet) => (
                        <ListItem unordered variant="body-1" key={bullet}>
                            {bullet}
                        </ListItem>
                    ))}
                </Stack>
            </ContentStack>
        </TitledSection>
    );
};

export default React.memo(NoResultsDisplay);
